// extracted by mini-css-extract-plugin
export var grid = "_6-5";
export var layout = "_6-0";
export var leftColumn = "_6-1";
export var leftInner = "_6-2";
export var rightColumn = "_6-3";
export var rightInner = "_6-4";